import { formatAmountForDisplay, toHundreds } from '../../flows/shared/utils';

export const DEFAULT_CURR_YR_MAX = age => (Number(age) < 50 ? 6000 : 7000);
export const DEFAULT_PRIOR_YR_MAX = age => (Number(age) <= 50 ? 6000 : 7000);

export const getAppropriateLimit = async (
  existingUserLimit,
  ageBasedLimit,
  defaultLimit,
  enabled,
  age
) => {
  if (enabled) return existingUserLimit;
  if (age) {
    const limits = await ageBasedLimit(age);
    return limits[0]?.contributionLimitAmount >= 0
      ? limits[0]?.contributionLimitAmount
      : defaultLimit;
  }
  return defaultLimit;
};

export const getTotalContributions = (
  yearContributionsSoFar,
  yearRemainingAutomaticPurchases
) => {
  return Math.round(yearContributionsSoFar + yearRemainingAutomaticPurchases);
};

export const didContributionMaxOut = (totalContributions, yearMaximumLimit) => {
  return totalContributions === yearMaximumLimit;
};

export const getInputTitle = (
  enabled,
  year,
  yearLimit,
  yearMaximumLimit,
  existingUserRemainingLimit,
  scheduledTransactions = false
) => {
  if (enabled) {
    return `You have ${formatAmountForDisplay(
      existingUserRemainingLimit >= 0 ? existingUserRemainingLimit : yearLimit
    )} remaining towards your annual IRA limit of
  ${formatAmountForDisplay(
    yearMaximumLimit
  )}. This is based on amounts contributed ${
      scheduledTransactions ? 'or are scheduled to be contributed' : ''
    } to your T. Rowe Price IRAs for ${year}.`;
  }

  return `Contribute up to ${formatAmountForDisplay(
    yearLimit
  )} based on the annual contribution limit for ${year}.`;
};

// [DE53320]- This function is needed to check if the contributions maxed out for a
// user who is enrolled in auto-max IRA, since service is not providing us the
// total contribution amount right now which includes scheduled transactions
export const getExistingUserRemainingContribLimit = (
  yearContributionsSoFar,
  yearRemainingAutomaticPurchases,
  yearMaximumLimit,
  yearRemainingContributions
) => {
  // get total contributions when user is enrolled in auto-max IRA
  const totalContributions = getTotalContributions(
    yearContributionsSoFar,
    yearRemainingAutomaticPurchases
  );
  // check if the total contributions maxed out
  const didContributonLimitMaxOut = didContributionMaxOut(
    totalContributions,
    yearMaximumLimit
  );
  return didContributonLimitMaxOut ? 0 : toHundreds(yearRemainingContributions);
};
